/**
 * One Google Maps place/search link, built from whatever text we have.
 *
 * The one caller left is the venue card: coordinates when the pin is set,
 * otherwise the address. Agenda items no longer carry a destination, so the
 * session card has no map link to build.
 *
 * The venue address is free text and the URL shape stays as it was when a
 * `destination` label was also accepted: a plain string, never a place id.
 * `destination_place_id` is only meaningful for a real Google place id, and
 * the only way to obtain one is the Places picker that is out of scope; the
 * legacy sentinels ("hotel", "venue-<uuid>") would produce a link that
 * resolves to nothing.
 */
export function mapsLocationUrl(location: string): string | null {
  const target = location.trim();
  if (!target) return null;
  const url = new URL("https://www.google.com/maps/search/");
  url.searchParams.set("api", "1");
  url.searchParams.set("query", target);
  return url.toString();
}
